import React from 'react';
import { formatCurrency } from '../utils/dateUtils.ts';
import './InvestmentIndicators.css';

interface MonthlyReturn {
  id: number;
  reference_month: string;
  opening_balance: number;
  closing_balance: number;
  monthly_return: number;
  monthly_return_pct: number;
}

interface IndicatorsProps {
  indicators: {
    cumulative_return: number;
    annual_return: number;
    cagr: number;
    max_drawdown: number;
    real_cumulative_return: number;
    real_annual_return: number;
    real_cagr: number;
    real_max_drawdown: number;
    monthly_returns: MonthlyReturn[];
    nominal_vs_real_note: string;
  } | null;
}

const InvestmentIndicators: React.FC<IndicatorsProps> = ({ indicators }) => {
  if (!indicators) {
    return (
      <div className="indicators-empty">
        Nenhum indicador disponível. Registre dados mensais para visualizar os resultados.
      </div>
    );
  }

  return (
    <div className="indicators-container">
      <div className="indicator-grid">
        <div className="indicator-card">
          <span>Retorno acumulado</span>
          <strong>{(indicators.cumulative_return * 100).toFixed(2)}%</strong>
        </div>
        <div className="indicator-card">
          <span>Retorno anual</span>
          <strong>{(indicators.annual_return * 100).toFixed(2)}%</strong>
        </div>
        <div className="indicator-card">
          <span>CAGR</span>
          <strong>{(indicators.cagr * 100).toFixed(2)}%</strong>
        </div>
        <div className="indicator-card">
          <span>Max drawdown</span>
          <strong>{(indicators.max_drawdown * 100).toFixed(2)}%</strong>
        </div>
      </div>

      {indicators.real_cagr !== 0 || indicators.real_cumulative_return !== 0 ? (
        <div className="indicator-grid">
          <div className="indicator-card">
            <span>Retorno acumulado (real)</span>
            <strong>{(indicators.real_cumulative_return * 100).toFixed(2)}%</strong>
          </div>
          <div className="indicator-card">
            <span>Retorno anual (real)</span>
            <strong>{(indicators.real_annual_return * 100).toFixed(2)}%</strong>
          </div>
          <div className="indicator-card">
            <span>CAGR (real)</span>
            <strong>{(indicators.real_cagr * 100).toFixed(2)}%</strong>
          </div>
          <div className="indicator-card">
            <span>Max drawdown (real)</span>
            <strong>{(indicators.real_max_drawdown * 100).toFixed(2)}%</strong>
          </div>
        </div>
      ) : null}

      <p className="indicator-note">{indicators.nominal_vs_real_note}</p>

      <div className="indicator-table">
        {indicators.monthly_returns.slice(0, 6).map((record) => (
          <div className="indicator-row" key={record.id}>
            <span>{record.reference_month}</span>
            <span>{formatCurrency(record.opening_balance)}</span>
            <span>{formatCurrency(record.closing_balance)}</span>
            <span>{(record.monthly_return_pct * 100).toFixed(2)}%</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InvestmentIndicators;
